import { IContentGameData, IContentSummaryData } from '@/types';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getContentSummary = async (
  month: number
): Promise<{ status: boolean; data: IContentSummaryData } | undefined> => {
  return serviceHelper(
    http.get(`/admin/content/summary?month=${month}`),
    false
  );
};

export const getContentList = async (
  query?: Record<string, unknown>
): Promise<
  { status: boolean; data: IContentGameData[]; total: number } | undefined
> => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/content${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const getContentDetails = async (
  id: string
): Promise<{ status: boolean; data: IContentGameData } | undefined> => {
  return serviceHelper(http.get(`/admin/content/${id}`), false);
};

export const updateContent = async (
  id: string,
  data: Record<string, unknown>
): Promise<{ status: boolean; message: string } | undefined> => {
  return serviceHelper(http.patch(`/admin/content/${id}`, data), false);
};

export const uploadPreviewImage = async (
  file: File
): Promise<
  { status: boolean; data: { id: string; url: string } } | undefined
> => {
  const formData = new FormData();
  formData.append('folder', 'game');
  formData.append('image', file);
  return serviceHelper(
    http.post('/upload/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
    false
  );
};

export const updateContentStatus = async (
  id: string,
  status: boolean
): Promise<{ status: boolean; message: string } | undefined> => {
  return serviceHelper(
    http.patch(`/admin/content/${id}/status`, { status }),
    false
  );
};

export const exportContentList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/content/export${queryString ? `?${queryString}` : ''}`, {
      responseType: 'blob',
    }),
    false
  );
};
